const nostoLoadMoreButton = document.querySelector('#nosto-load-more')
if (nostoLoadMoreButton) {
  const params = new URLSearchParams(window.location.search)

  let PAGE = Number(params.get('page')) || 1
  const handleIntersection = (entries, observer) => {
    if (entries[0].isIntersecting) {
      if (PAGE <= 3) {
        PAGE++
        nostoLoadMoreButton.classList.add('visible')
        setTimeout(() => {
          nostoLoadMoreButton.click()
          nostoLoadMoreButton.classList.remove('visible')
        }, 1000)
      } else {
        nostoLoadMoreButton.classList.add('visible', 'btn-solid', 'btn-plus')
        observer.disconnect()
      }
    }
  }

  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px -20% 0px'
  })

  observer.observe(nostoLoadMoreButton)
}
